import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const ticketApi = {
  getTicketTags: (request) => {
    return instance().get(`/tickets-tags`, { params: request })
  },
  getTicketTagsList: (pageId, params) => {
    return instance().get(`/page/${pageId}/ticket-tag-list`, { params })
  }
}

export default ticketApi



// WEBPACK FOOTER //
// ./src/api/ticket.js